<template>
    <Modal class="popup_content" v-model="couponShows" width="400" @on-cancel="couponCancel">
        <div slot="header" class="popup_header_content">
            <span>支付记录</span>
        </div>
        <div class="popup_head_body">
            <div class="payrecord_content" v-if="couponinfo != undefined">
                <span>￥{{couponinfo.cost}}</span>
                <div class="payrecord_list_content">
                    <Row>
                        <Col span="7"><span>优惠券名称</span></Col>
                        <Col span="17"><p>{{couponinfo.name}}</p></Col>
                    </Row>
                    <Row>
                        <Col span="7"><span>使用门槛</span></Col>
                        <Col span="17"><p v-if="couponinfo.limitcost > 0">满{{couponinfo.limitcost}}元可用</p><p v-else>无限制</p></Col>
                    </Row>
                    <Row v-if="couponinfo.personcount">
                        <Col span="7"><span>每人领取</span></Col>
                        <Col span="17"><p>{{couponinfo.personcount}}张</p></Col>
                    </Row>
                    <Row>
                        <Col span="7"><span>有效日期</span></Col>
                        <Col span="17"><p>{{couponinfo.sdatex || couponinfo.sdate}}至{{couponinfo.edatex || couponinfo.edate}}</p></Col>
                    </Row>
                    <Row>
                        <Col span="7"><span>商品范围</span></Col>
                        <Col span="17"><span v-for="(range, sign) in couponinfo.goodsrangevalue" :key="sign">{{range}}<small v-if="sign != couponinfo.goodsrangevalue.length">、</small></span></Col>
                    </Row>
                    <Row>
                        <Col span="7"><span>使用说明</span></Col>
                        <Col span="17"><p>{{couponinfo.instructions}}</p></Col>
                    </Row>
                </div>
            </div>
        </div>
        <div slot="footer"></div>
    </Modal>
</template>

<script>
    export default {
        props: ['couponShow', 'couponinfo'],
        data() {
            return {
                couponShows: false, // 弹窗是否显示
            }
        },
        methods: {
            couponCancel () { // 关闭按钮
                this.couponShows = false
                this.$emit('couponCancel')
            }
        },
        watch: {
            couponShow () {
                this.couponShows = this.couponShow
                console.log(this.couponinfo)
            }
        }
    }
</script>

<style scoped>

.payrecord_content > span {
    text-align: center;
    font-size: 18px;
    color: #FF8000;
    display: block;
}

.payrecord_list_content > .ivu-row {
    padding: 10px 0;
    border-bottom: 1px solid #f0f0f0;
}

.payrecord_list_content > .ivu-row:last-child {
    border-bottom: none;
}

.payrecord_list_content span {
    font-size: 14px;
    color: #333;
}

.payrecord_list_content p {
    font-size: 14px;
    color: #666;
    word-break: break-all;
}

.payrecord_list_img {
    position: relative;
}

.payrecord_list_img > img {
    max-width: 100%;
    max-height: 440px;
    position: absolute;
    left: 0;
    bottom: 100%;
    z-index: 1;
}

.payrecord_list_img > ul {
    font-size: 0;
}

.payrecord_list_img > ul > li {
    width: 60px;
    height: 60px;
    margin: 8px 8px 0 0;
    display: inline-block;
    background-color: #333;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    cursor: pointer;
}

</style>


// WEBPACK FOOTER //
// src/components/component/popup/seecoupon.vue